//style
import style from "./ContentLayout.module.css";

export const ContentLayout: React.FC = ({ children }) => {
  return <div className={style.content}>{children}</div>;
};
